module.exports = __webpack_public_path__ + "static/media/office.7fab78af.png";